import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/common/Sidebar';
import Header from '../components/common/Header';
import PushNotificationManager from '../components/notifications/PushNotificationManager';
import IOSInstallBanner from '../components/notifications/IOSInstallBanner';
import SupportFAB from '../components/common/SupportFAB';

const PrivateLayout = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <div className="flex flex-col lg:flex-row h-screen bg-gray-100">
      {/* Push Notification Manager - handles background notifications */}
      <PushNotificationManager />

      {/* iOS install guide — only shown to iOS Safari users who haven't installed the PWA */}
      <IOSInstallBanner />

      {/* Mobile floating support button — hidden on desktop where the sidebar shows contact info */}
      <SupportFAB />
      
      <Sidebar isOpen={mobileMenuOpen} onClose={closeMobileMenu} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header onMenuToggle={toggleMobileMenu} />
        <main className="flex-1 overflow-y-auto p-4 sm:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default PrivateLayout;
